export const FETCH_QUOTE = 'FETCH_QUOTE';
export const CHANGE_COLOR = 'CHANGE_COLOR';
